import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import { BlockViewExtension } from '@blocksuite/std';
import { literal } from 'lit/static-html.js';

import { effects } from './effects';
import { EditPropsMiddlewareBuilder } from './extensions';
import { ExportManagerExtension } from './extensions/export-manager/export-manager';
import { DefaultTool } from './tool/default-tool';
import { registerSurfaceViewing, surfaceViewingBlock } from './viewing';

export class SurfaceViewExtension extends ViewExtensionProvider {
  override name = 'affine-surface-block';

  override effect() {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    registerSurfaceViewing(context);
    context.register(ExportManagerExtension);
    if (this.isEdgeless(context.scope)) {
      context.register(DefaultTool);
      context.register(surfaceViewingBlock());
      context.register(EditPropsMiddlewareBuilder);
    } else {
      context.register(
        BlockViewExtension('affine:surface', literal`affine-surface-void`)
      );
    }
  }
}
